import React from 'react'
import { Link } from 'react-router-dom'
import iner from '../../../assets/images/about/arrow-brudcrumb.svg'

const MenPageInear = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: "url(assets/images/background/shop-details-page-bg.jpg)"
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow"
                                data-wow-duration="2000ms"
                            >
                                <h2>Product Details</h2>
                                <p className="lead">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews.
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={iner} alt="icon" />
                        </li>
                        <li>
                            <span>Handbag</span>
                        </li>
                    </ul>
                </div>
            </div >

        </>
    )
}

export default MenPageInear
